let _$q;

const ConfirmationDialogService = function ($q) {
    _$q = $q;
};

ConfirmationDialogService.prototype.showConfirmationDialog = function (opts) {

    // Set options
    this.showDialog = true;
    this.message = opts.message;
    this.classes = opts.classes;

    // Create a promise and return it.
    this.deferred = _$q.defer();

    return this.deferred.promise;
};

ConfirmationDialogService.prototype.resolveDialog = function (result) {
    if (result) {
        this.deferred.resolve(result);
    } else {
        this.deferred.reject('cancel');
    }
    this.showDialog = false;
};

module.exports = ConfirmationDialogService;



// WEBPACK FOOTER //
// ./src/olycommon/confirmation-dialog/confirmation-dialog.service.js